
<div class="functionality-dialog">

  <div
    *ngIf="functionalitiesLoading"
    class="functionality-loading"
    role="status"
    aria-live="polite"
  >
    <img
      src="assets/icons/loading-spinner.svg"
      alt="Caricamento funzionalità"
      class="functionality-loading-image"
    />
    <span>Caricamento funzionalità in corso...</span>
  </div>

  <ng-container *ngIf="!functionalitiesLoading">

    <div class="functionality-dialog-body">

      <p-table
        #dt
        styleClass="p-datatable-sm functionality-table"
        [value]="functionalities"
        [scrollable]="true"
        selectionMode="multiple"
        scrollDirection="both"
        scrollHeight="flex"
        [style]="{ width: '100%' }"
        [globalFilterFields]="[
          'name',
          'visibleName',
          'description',
          'path'
        ]"
        [selection]="selectedFunctionality"
        (selectionChange)="onAllSelected($event)"
      >

        <ng-template pTemplate="caption">
          <div class="functionality-table-caption">

            <div class="functionality-table-summary">
              <div class="functionality-table-summary-icon">
                <i class="pi pi-list"></i>
              </div>

              <div class="functionality-table-summary-text">
                <strong>Elenco funzionalità</strong>
                <span>
                  {{ functionalities.length }}
                  {{ functionalities.length === 1
                    ? 'funzione disponibile'
                    : 'funzioni disponibili' }}
                </span>
              </div>
            </div>

            <div class="functionality-toolbar">

              <div class="functionality-toolbar-left">
                <p-button
                  *ngIf="!isChangeMode"
                  label="Nuova funzione"
                  icon="pi pi-plus"
                  [disabled]="currentlyEditing !== null"
                  (onClick)="createNewFunctionality()"
                  styleClass="functionality-add-button"
                ></p-button>

                <div
                  *ngIf="isChangeMode"
                  class="functionality-selection-info"
                >
                  <i class="pi pi-check-square"></i>
                  <span>Seleziona le funzioni da autorizzare</span>
                </div>
              </div>

              <div class="functionality-toolbar-right">

                <div class="functionality-search">
                  <i class="pi pi-search"></i>

                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="search"
                    (ngModelChange)="dt.filterGlobal(search, 'contains')"
                    placeholder="Cerca funzionalità..."
                    aria-label="Cerca funzionalità"
                  />
                </div>

                <p-button
                  *ngIf="search !== ''"
                  icon="pi pi-filter-slash"
                  [outlined]="true"
                  (onClick)="search = ''; dt.filterGlobal(search, 'contains')"
                  pTooltip="Cancella ricerca"
                  tooltipPosition="top"
                  styleClass="functionality-icon-button"
                ></p-button>

                <p-button
                  label="Aggiorna"
                  icon="pi pi-refresh"
                  [outlined]="true"
                  (onClick)="loadFunctionalities()"
                  styleClass="functionality-refresh-button"
                ></p-button>

              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th
              *ngIf="isChangeMode"
              class="functionality-checkbox-column"
            >
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>

            <th
              *ngIf="!isChangeMode"
              class="functionality-actions-column"
            >
              Azioni
            </th>

            <th pSortableColumn="name">
              <div class="functionality-column-heading">
                Nome tecnico
                <p-sortIcon field="name"></p-sortIcon>
              </div>
            </th>

            <th pSortableColumn="visibleName">
              <div class="functionality-column-heading">
                Nome comune
                <p-sortIcon field="visibleName"></p-sortIcon>
              </div>
            </th>

            <th pSortableColumn="description">
              <div class="functionality-column-heading">
                Descrizione
                <p-sortIcon field="description"></p-sortIcon>
              </div>
            </th>

            <th>Percorso</th>

            <th class="functionality-transactional-column">
              Transazionale
            </th>

            <th class="functionality-operations-column">
              Operazioni
            </th>
          </tr>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-functionality
          let-rowIndex="rowIndex"
        >
          <tr
            [class.functionality-editing-row]="
              functionality.functionId === currentlyEditing?.functionId
            "
          >

            <td
              *ngIf="isChangeMode"
              class="functionality-checkbox-cell"
            >
              <p-tableCheckbox
                [value]="functionality"
              ></p-tableCheckbox>
            </td>

            <td
              *ngIf="!isChangeMode"
              class="functionality-actions-cell"
            >
              <div class="functionality-row-actions">

                <ng-container
                  *ngIf="
                    functionality.functionId === currentlyEditing?.functionId
                  "
                >
                  <p-button
                    icon="pi pi-save"
                    (onClick)="modifyFunction()"
                    styleClass="functionality-action-button functionality-save-button"
                    pTooltip="Salva"
                    tooltipPosition="top"
                  ></p-button>

                  <p-button
                    icon="pi pi-times"
                    (onClick)="editFunction(null, rowIndex)"
                    styleClass="functionality-action-button functionality-cancel-button"
                    pTooltip="Annulla"
                    tooltipPosition="top"
                  ></p-button>
                </ng-container>

                <ng-container
                  *ngIf="
                    functionality.functionId !== currentlyEditing?.functionId
                  "
                >
                  <p-button
                    icon="pi pi-pencil"
                    (onClick)="editFunction(functionality, rowIndex)"
                    styleClass="functionality-action-button functionality-edit-button"
                    pTooltip="Modifica"
                    tooltipPosition="top"
                  ></p-button>

                  <p-button
                    icon="pi pi-trash"
                    (onClick)="removeFunction(functionality, rowIndex)"
                    styleClass="functionality-action-button functionality-delete-button"
                    pTooltip="Elimina"
                    tooltipPosition="top"
                  ></p-button>
                </ng-container>

              </div>
            </td>

            <ng-container
              *ngIf="
                functionality.functionId === currentlyEditing?.functionId
              "
            >
              <td>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="functionality.name"
                  class="functionality-edit-input"
                  placeholder="Nome tecnico"
                />
              </td>

              <td>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="functionality.visibleName"
                  class="functionality-edit-input"
                  placeholder="Nome comune"
                />
              </td>

              <td>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="functionality.description"
                  class="functionality-edit-input"
                  placeholder="Descrizione"
                />
              </td>

              <td>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="functionality.path"
                  class="functionality-edit-input"
                  placeholder="Percorso"
                />
              </td>

              <td>
                <p-toggleButton
                  [(ngModel)]="functionality.isTransactional"
                  onLabel="Sì"
                  offLabel="No"
                  styleClass="functionality-transactional-toggle"
                ></p-toggleButton>
              </td>

              <td>
                <p-autoComplete
                  [(ngModel)]="selectedOperations"
                  [suggestions]="filteredOperations"
                  field="operation"
                  (completeMethod)="filterOperation($event)"
                  [multiple]="true"
                  styleClass="functionality-operations-autocomplete"
                ></p-autoComplete>
              </td>
            </ng-container>

            <ng-container
              *ngIf="
                functionality.functionId !== currentlyEditing?.functionId
              "
            >
              <td>
                <span class="functionality-technical-name">
                  {{ functionality.name }}
                </span>
              </td>

              <td>
                <span class="functionality-visible-name">
                  {{ functionality.visibleName }}
                </span>
              </td>

              <td>
                <span class="functionality-description">
                  {{ functionality.description || '—' }}
                </span>
              </td>

              <td>
                <span class="functionality-path">
                  {{ functionality.path || '—' }}
                </span>
              </td>

              <td>
                <span
                  class="functionality-status"
                  [ngClass]="
                    functionality.isTransactional
                      ? 'functionality-status-yes'
                      : 'functionality-status-no'
                  "
                >
                  <i
                    class="pi"
                    [ngClass]="
                      functionality.isTransactional
                        ? 'pi-check-circle'
                        : 'pi-minus-circle'
                    "
                  ></i>

                  {{ functionality.isTransactional ? 'Sì' : 'No' }}
                </span>
              </td>

              <td>
                <div class="functionality-operations-list">

                  <span
                    class="functionality-operation-tag"
                    *ngFor="
                      let op of functionality.functionalityRequiredOperations
                    "
                  >
                    {{ getOperation(op) }}
                  </span>

                  <span
                    class="functionality-empty-value"
                    *ngIf="
                      !functionality.functionalityRequiredOperations?.length
                    "
                  >
                    Nessuna
                  </span>

                </div>
              </td>
            </ng-container>

          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td
              colspan="7"
              class="functionality-empty-cell"
            >
              <div class="functionality-empty-state">
                <i class="pi pi-inbox"></i>
                <h3>Nessuna funzionalità trovata</h3>
                <p>
                  Non ci sono funzionalità corrispondenti alla ricerca.
                </p>
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>

    <div
      class="functionality-dialog-footer"
      *ngIf="isChangeMode"
    >
      <div class="functionality-footer-info">
        <i class="pi pi-info-circle"></i>
        <span>
          Conferma per salvare la selezione delle autorizzazioni.
        </span>
      </div>

      <div class="functionality-footer-actions">
        <p-button
          label="Annulla"
          icon="pi pi-times"
          [outlined]="true"
          severity="secondary"
          (onClick)="cancel()"
          styleClass="functionality-footer-cancel"
        ></p-button>

        <p-button
          label="Conferma"
          icon="pi pi-check"
          (onClick)="confirm()"
          styleClass="functionality-footer-confirm"
        ></p-button>
      </div>
    </div>

  </ng-container>

</div>
